import { LOADING } from '../actions.type';
import initialState from '../initialState';

export default function(state = initialState.loading, action) {
  switch (action.type) {
    case LOADING:
      return action.loading;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/loading/loading.reducer.js